import type { ScrollTweenFunction } from '../types';
import { gsap } from 'gsap';

/**
 * ScrollCards Animation Logic
 */
export const scrollCards: ScrollTweenFunction = ({
    target, scrollTimeline, direction, top, pageIndex, numberOfPages, duration, insertTweenAt, containersToTap
}) => {
    if (!scrollTimeline || typeof pageIndex === 'undefined' || typeof numberOfPages === 'undefined' || typeof duration === 'undefined' || typeof insertTweenAt === 'undefined') return;
    if (pageIndex > numberOfPages) return;


    if (direction === "forward" || direction === "init") {
        if (top) {
            if (pageIndex < numberOfPages) {
                const tween = gsap.to(target, { y: "-20%", ease: "none", scale: 0.7, autoAlpha: 0, duration });
                scrollTimeline.add(tween, insertTweenAt);
            }
        } else {
            gsap.set(target, { y: "120%", autoAlpha: 1 });
            const tween = gsap.to(target, { scale: 1, y: 0, autoAlpha: 1, ease: "none", duration });
            scrollTimeline.add(tween, "<");
        }
    }

    if (direction === "back") {
        const backDuration = containersToTap ? 50 : 100;
        const backInsertTweenAt = containersToTap ? 50 : 0;
        if (top) {
            // Replicates original fromTo logic
            gsap.set(target, { y: "0%", scale: 1, autoAlpha: 1 });
            const tween = gsap.to(target, { y: "-20%", autoAlpha: 0, scale: .7, duration: backDuration, ease: "none" });
            scrollTimeline.add(tween, backInsertTweenAt);
        } else {
            // Replicates original from logic
            gsap.set(target, { y: "120%", scale: 1, autoAlpha: 0 }); // Set the 'from' state
            const tween = gsap.to(target, { y: "0%", autoAlpha: 1, duration: backDuration, ease: "none" }); // Animate 'to' the final state
            scrollTimeline.add(tween, "<");
        }
    }
};
